import axios from '../index';

export const getInspectConfigData = async () => {
  return axios.get(`api/elastic/inspect_config`);
};

export const getInspectData = async (filterResult, signal) => {
  return axios.post(`api/elastic/inspect`, filterResult, { signal: signal });
};

export const getInspectInnerSearchData = async (filterResult, signal) => {
  return axios.post(`api/elastic/inspect_trend`, filterResult, { signal: signal });
};

export const getInspectPlayerConfigData = async () => {
  return axios.get(`api/elastic/inspect_player_config`);
};

export const getInspectPlayerData = async (data, signal) => {
  return axios.post(`api/elastic/inspect_player`, data, { signal: signal });
};

export const getTranscriptSearchData = (params) => {
  return axios.post(`api/elastic/transcript_search`, params);
};

export const getEvaluationFormData = async (id, signal) => {
  return axios.post(`api/elastic/get_evaluation_form_data`, { call_id: id }, { signal: signal });
};

export const createEvaluationFormData = async (params) => {
  return axios.post(`api/elastic/create_evaluation_form_data`, params);
};
